<template>
    <div>
        <span v-html="errorNotFoundDocuments"></span>
        <div v-for="document in documents" :key="document.id">
            <div :id="`document-${document.slug}-preview`" class="row">
                <div class="col-md-12">
                    <div class="form-group">
                        <label :for="`image-${document.slug}`">{{ document.name }}{{ document.required ? " *" : "" }}</label>
                        <div :id="`image-${document.slug}-preview`" class="form-group">
                            <label :id="`image-${document.slug}-label`">{{ trans('provider.upload') }}</label>
                            <VueFileAgent
                                :ref="`file-${document.slug}`"
                                :name="`docs[${document.id}]`"
                                :theme="'list'"
                                :multiple="false"
                                :deletable="true"
                                :meta="true"
                                :accept="'image/*,.pdf,.doc,.docx'"
                                :helpText="trans('providerController.choose_document')"
                                :errorText="{
                                type: 'Invalid file type. Only images and documents allowed',
                                }"
                            >
                            </VueFileAgent>
                          <button
                              @click="() => {$refs[`file-${document.slug}`][0].fileRecords = []}"
                              class="btn btn-outline-red mt-1"
                          >
                            {{ trans('providerController.remove_image') }}
                          </button>
                            <a 
                                v-if="getDocumentUrl(document.id)" 
                                :href="getDocumentUrl(document.id)"
                                target="_blank"
                            >{{trans('providerController.current_document')}}</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Insert field experation date if true -->
            <div class="row" v-if="document.has_validity">
                <div class="col-md-12">
                    <div class="form-group">
                        <label>{{ trans('document.date_validity') + '*' }}</label>
                        <div class="input-group">
                            <DatePicker
                                v-model="documentDates[`date-${document.id}`]"
                                :lang="lang"
                                @change="changeDate"
                                format="DD/MM/YYYY"
                                placeholder="DD/MM/YYYY"
                                valueType="DD/MM/YYYY"
                                :ref="`date-${document.id}`" 
                                :name="`date-${document.id}`"
                                :disabled-date="disabledBeforeToday"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import Vuetify from 'vuetify';
import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/pt-br';
import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/index.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import _ from "lodash";
Vue.use(Vuetify);

Vue.use(VueFormWizard);

export default {
    components: { DatePicker },
    props: {
        documentsModel: Object,
        documents: Array,
        base_url: String,
        providerId: Number | String,
    },
	vuetify: new Vuetify(),
    data() {
        return {
            errorNotFoundDocuments: "",
            document_array: [],
            documentDates: [],
            docs: null,
			lang: "pt-br"
        }
    },
    methods: {
      trans(key) {
        return _.get(window.lang, key, key);
      },
        changeDate() {
            this.$nextTick();
        },
        disabledBeforeToday(date){
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            return date < today;
        },
        getDocumentUrl(id) {
            var url = "";

            for (var document of this.document_array) {
                if (document.document_id == id) {
                    return document.url;
                }
            }

            return url;
        },
        validate() {
            var valid = true;
            var doc = {};
            this.documentsModel.docs = [];
            this.errorNotFoundDocuments = "";
            
            for (var document of this.documents) {
                if (document.has_validity) {
                    if (!this.documentDates[`date-${document.id}`] || this.documentDates[`date-${document.id}`].length == 0) {
                        this.errorNotFoundDocuments +=
                        `<div class="help-block with-errors"><span>${this.trans('providerController.expiration_date')} ${document.name}  ${this.trans('providerController.is_required')}</span></div>`;
                        
                        valid = false;
                    }
                }
                if (document.required) {
                    if (this.$refs[`file-${document.slug}`][0].fileRecords.length == 0 && this.getDocumentUrl(document.id) == "") {
                        this.errorNotFoundDocuments +=
                        `<div class="help-block with-errors"><span>${document.name}  ${this.trans('providerController.is_required')} </span></div>`;
                        
                        valid = false;
                    }
                }
                if (this.$refs[`file-${document.slug}`][0].fileRecords.length != 0) {
                    doc = {
                        doc_id: document.id,
                        document: this.$refs[`file-${document.slug}`][0].fileRecords[0].file,
                        validity:  document.has_validity ? this.documentDates[`date-${document.id}`] : '',
                    };

                    this.documentsModel.docs.push(doc);
                }
            }

            return valid;
        },
        async save() {
            try {
                var valid = true;
                for (var document of this.documentsModel.docs) {
                    var formData = new FormData();
                    
                    for (var key in document) {
                        var value = document[key];
                        
                        formData.append(key, value);
                    }

                    formData.append('origin', 'web');

                    if (this.providerId) {
                        formData.append('provider', this.providerId);
                        formData.append('provider_id', this.providerId);
                    }

                    if (document == this.documentsModel.docs.slice(-1)[0]) {
                        formData.append('status', 'approved');
                    }

                    Swal.fire({
                        text: 'Salvando documentos...',
                    });
                    Swal.showLoading();
                    var json_result = await axios.post(this.base_url + '/api/v2/provider/wizard/save_document', formData,
                        {
                            crossDomain: true,
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });
                
                    if (json_result.data.success == true) {
                        this.providerId = json_result.data.provider.id;
                        Swal.close();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: json_result.data.errors,
                        });

                        return false;
                    }
                }

                if (this.documentsModel.docs.length == 0) {
                    var formData = new FormData();
                    formData.append('origin', 'web');

                    if (this.providerId) {
                        formData.append('provider_id', this.providerId);
                    }

                    Swal.fire({
                        text: this.trans('saving_provider'),
                    });
                    Swal.showLoading();
                    var json_result = await axios.post(this.base_url + '/api/v2/provider/wizard/approve_provider', formData,
                        {
                            crossDomain: true,
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });
                
                    if (json_result.data.success == true) {
                        this.providerId = json_result.data.provider.id;
                        Swal.close();
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: json_result.data.errors,
                        });

                        return false;
                    }
                }

                return valid;
            } catch(error) {
                alert(error);
                Swal.close();
                return false;
            }
        }
    },
  deleteUploadedFile: function (fileRecord) {
    // Using the default uploader. You may use another uploader instead.
    this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
  },
    mounted() {},
    created() {}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="./register.css"></style>
<style>
@import "https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900";
@import "https://cdn.jsdelivr.net/npm/@mdi/font@6.x/css/materialdesignicons.min.css";
@import "https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css";
</style>